import styled from 'styled-components';

const baseVariables = {
  mediaQuery: {
    mobile: '(max-width: 767px)',
    tablet: '(min-width: 768px) and (max-width: 991px)',
    desktop: '(min-width: 992px)',
  },
  spacing: {
    xs: '0.5rem',
    s: '1rem',
    m: '1.5rem',
    l: '2rem',
    xl: '2.5rem',
    xxl: '3rem',
  },
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-inline: auto;
  padding-block: ${baseVariables.spacing.l};
  padding-inline: ${baseVariables.spacing.s};

  @media ${baseVariables.mediaQuery.tablet} {
    padding-block: ${baseVariables.spacing.xl};
    padding-inline: ${baseVariables.spacing.m};
  }

  @media ${baseVariables.mediaQuery.desktop} {
    padding-block: ${baseVariables.spacing.xxl};
    padding-inline: ${baseVariables.spacing.l};
    max-width: 1200px;
  }
`;

const HeaderWrapper = styled.div`
  margin-block-end: ${baseVariables.spacing.l};

  @media ${baseVariables.mediaQuery.tablet} {
    margin-block-end: ${baseVariables.spacing.xl};
  }

  @media ${baseVariables.mediaQuery.desktop} {
    margin-block-end: ${baseVariables.spacing.xxl};
  }
`;

const CardsGrid = styled.div<{ $desktopColumns: number }>`
  display: grid;
  gap: ${baseVariables.spacing.m};
  grid-template-columns: 1fr;

  @media ${baseVariables.mediaQuery.tablet} {
    grid-template-columns: repeat(2, 1fr);
    gap: ${baseVariables.spacing.l};
  }

  @media ${baseVariables.mediaQuery.desktop} {
    grid-template-columns: ${({ $desktopColumns }) => `repeat(${$desktopColumns}, 1fr)`};
    gap: ${baseVariables.spacing.l};
  }

  & > * {
    min-width: 0;
  }
`;

export default {
  Container,
  HeaderWrapper,
  CardsGrid,
};
